export const getOpen = (state) => state.auth.updatePassword.open;
export const getCurrentPassword = (state) => state.auth.updatePassword.currentPassword;
export const getPassword = (state) => state.auth.updatePassword.password;
export const getConfirmPassword = (state) => state.auth.updatePassword.confirmPassword;
export const getErrors = (state) => state.auth.updatePassword.errors;
export const getLoading = (state) => state.auth.updatePassword.loading;
